import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './queryClient';
import { injectCssVariables } from './theme';
import { AuthProvider } from './context/AuthContext';
import { initErrorTracking } from './services/errorTracking';
import { registerNotificationServiceWorker } from './services/browserPushService';
import { ConfigProvider, theme as antdTheme } from 'antd';

injectCssVariables();
initErrorTracking();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ConfigProvider theme={{ algorithm: antdTheme.darkAlgorithm }}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ConfigProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

void registerNotificationServiceWorker();
